import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-docs-icon',
  template: `
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_44491_25079)">
        <path
          d="M6.55642 13.3615H12.7786V14.9171H6.55642V13.3615ZM6.55642 10.2504H12.7786V11.806H6.55642V10.2504ZM11.2231 2.47266L5.00087 2.47266C4.14531 2.47266 3.44531 3.17266 3.44531 4.02821L3.44531 16.4727C3.44531 17.3282 4.13753 18.0282 4.99309 18.0282H14.3342C15.1898 18.0282 15.8898 17.3282 15.8898 16.4727V7.13932L11.2231 2.47266ZM14.3342 16.4727H5.00087L5.00087 4.02821H10.4453V7.9171L14.3342 7.9171V16.4727Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_44491_25079">
          <rect
            width="18.6667"
            height="18.6667"
            fill="white"
            transform="translate(0.333984 0.916992)"
          />
        </clipPath>
      </defs>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocsIconComponent {}
